import { Navigate } from "react-router-dom";
import { Login } from "../pages/Login/Login";
import { ParticipantInfo } from "../pages/Participant/ParticipantInfo";
import { CompanySchedulerIntra } from "../containers/CompanyCalendar/CompanySchedulerIntra";

export const publicRoutes = [
  {
    path: "/",
    element: <Login />,
  },
  { path: "*", element: <Navigate to="login" /> },
  { path: "/participant/:id", element: <ParticipantInfo /> },
  { path: "/company-calendar", element: <CompanySchedulerIntra /> },
];
